<template>
  <div class="order-page">
    <el-card class="box-card">
      <!-- el-form -->
    </el-card>
    <el-card class="button-box">
      <action-line @action-line="handleActionLine" :list="Desc.actionLine">
        <!-- <el-button @click="searchAreaStatus = !searchAreaStatus">{{ searchAreaStatus ? "收起" : "展开" }}</el-button> -->
      </action-line>
    </el-card>

    <!-- el-table -->
    <el-card>
      <el-row class="pagation-row">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryPrdlists.pagenum"
          :page-size="queryPrdlists.pagesize"
          :page-sizes="[10, 20, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </el-row>
    </el-card>
    <export-dialog ref="refExportDialog" @submit="exportSubmit" />
  </div>
</template>

<script>
import SearchMixin from "@/common/mixins/search-mixin";
import ActionLine from "@/common/mixins/action-line";
import { dealReturn } from "@/common/js/index.js";
import * as Desc from "./desc";
export default {
  mixins: [ActionLine, SearchMixin],
  data() {
    return {
      form: {},
      loading: false,
      tableData: [],
      Desc,
    };
  },
  created() {
    // this.getTableData();
  },
  methods: {
   
    async getTableData() {
      this.loading = true;
      let { data, err } = await this.axiosApi(
        Desc.list_api,
        this.queryPrdlists
      );
      // console.log("data", data);
      this.loading = false;
      this.tableData = data.data.data.data;
      this.total = parseInt(data.data.data.total);
      dealReturn(data, err);
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/template/index.vue